<template>
    <div class="service-wrap pt-20 pb-20">
        <div class="container">
            <!-- TABLEAU SOIRÉES THÉOLOGIQUES -->
            <div class="row mb-5">
            <div class="col-12">
                <!-- <h3 class="mb-2">Soirées théologiques</h3> -->
                <p class="mb-3">
                Elles créent des espaces de débats théologiques en modalités interdisciplinaires
                sur diverses préoccupations ecclésiales et sociales.
                </p>

                <div class="table-responsive">
                <table class="table table-bordered table-striped">
                    <thead class="table-light">
                    <tr>
                        <th>Dates</th>
                        <th>Thèmes</th>
                        <th>Communicateurs</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, index) in soireesTheologiques" :key="index">
                        <td>{{ item.date }}</td>
                        <td>{{ item.theme }}</td>
                        <td>{{ item.communicateur }}</td>
                    </tr>
                    </tbody>
                </table>
                </div>
            </div>
            </div>


            <div class="row ">
                <div class="col-xl-4 col-lg-6 col-md-6" v-for="(article, index) in truncatedArticles" :key="index">
                    <div class="blog-card style1">
                        <div class="blog-img"  :style="{height:'277px', backgroundImage: `url(${getUrlApiForFiles(article.urlImage)})`, backgroundSize: 'cover',backgroundPosition: 'center'}"
                        >
                        </div>
                        <div class="blog-info" style="min-height: 250px;">
                            <ul class="blog-metainfo  list-style">
                                <li><i class="flaticon-user"></i> <router-link to="#">L' École d’Initiation Théologique et Pastorale</router-link></li>
                                <li><i class="flaticon-calendar"></i>{{ format_Date(article.datePublication)  }}</li>
                            </ul>
                            <h3><router-link :to="{ name: 'ViewArticlePage', params: { id: article.id } }">{{ article.titre }}</router-link></h3>
                            <router-link :to="{ name: 'ViewArticlePage', params: { id: article.id } }" class="link style1">Lire plus
                                <i class="flaticon-right-arrow"></i>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div> 
            <div class="">
                <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
            </div>
        </div>
    </div>
</template>

<script lang="ts">

import ApiService from "@/services/ApiService";
import { getUrlApiForFiles, error,format_Date } from "@/utils/utils";
import { defineComponent, ref, onMounted, computed } from "vue";
import { Article } from "@/models/Article";
import PaginationComponent from '@/components/Utilities/Pagination.vue';

export default defineComponent({
    name: 'LesSoireestheologiques',
    components: {
      PaginationComponent,

  },
  setup(){

    const articles = ref<Array<Article>>([]);   

        // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);
    const soireesTheologiques = ref([
  {
    date: "29/11/2025",
    theme: "La démocratie en Afrique / La démocratie au Bénin / Débat à la soirée théologique ",
    communicateur: "M. Roger Ekoué FOLIKOUE / M. Joël Atayi Guèdegbe / M. Roger Ekoué FOLIKOUE, M. Joël Atayi Guèdegbe ",
  },

  {
    date: "30/11/2024",
    theme: "Le chrétien face aux défis économiques / Débat à la soirée théologique",
    communicateur: "M. Éric AKOUETE / M. Éric AKOUETE, M. Francis AGBO",
  },
  {
    date: "25/11/2023",
    theme: "Les démocraties en crise en Afrique. Défis pour l’Eglise / Débat à la soirée théologique",
    communicateur: "Maître Robert DOSSOU / Professeur Christian KITI, M. Paul-Marie HOUESSOU",
  },
  {
    date: "16/11/2022",
    theme: "Les forces ou pesanteurs de la religion pour le développement / Foi et prospérité / Conférence de presse théologique",
    communicateur: "M. Cossi Augustin AHOGA / Père Antoine TIDJANI / Père Rodrigue GBÉDJINOU",
  },
  {
    date: "27/11/2021",
    theme: "La justice comme condition d’existence du Peuple de la Bible / Le droit et la justice dans nos cultures / Droit et justice comme fondements de l’État de Droit / Débat à la soirée théologique / Synthèse",
    communicateur: "Père Raoul TÉKOU / M. Nicolas Luc A. ASSOGBA / Mme Blanche SONON / Mme Claire HOUNGAN AYÉMONNA, M. Victor TOPANOU / Père Rodrigue GBÉDJINOU ",
  },
  {
    date: "28/11/2020",
    theme: "Entre déconstruction et reconstruction : l’avenir des cultures africaines en question / Savoirs africains et rationalité : l’exigence d’une lecture décomplexée / La culture africaine à l’épreuve de l’afro-pessimisme. Quel avenir ? / Débat à la soirée théologique",
    communicateur: "Père Guy d’OLIVEIRA / M. Laurent Désiré MÈDÉGNON / Père Senyanu Louis HONDOCODO / M. Laurent Désiré MÈDÉGNON, Père Senyanu Louis HONDOCODO ",
  },
  {
    date: "07/09/2019",
    theme: "Ecclesia in Africa : Gaudium et spes ; luctus et angor / Faire la théologie aujourd’hui : esquisse d’une approche méthodologique / Les défis et nouveaux visages de la mission en Afrique aujourd’hui / Le SCEAM, instrument ecclésial de communion ? /  L’Église en Afrique : joies et espoirs / Les tristesses et angoisses de l’Église en Afrique / Débat entre deux théologiens",
    communicateur: "Père Rodrigue GBÉDJINOU / Pasteure Fifamè Fidèle HOUSSOU, Père Laurent KPOGO / Père Moïse ADÉKAMBI / Père Nathanaël SOÉDÉ / Père Édouard ADÈ / Père Nathanaël SOÉDÉ, Père Édouard ADÈ ",
  },
  {
    date: "15/09/2018",
    theme: "Les grandes interpellations de Fides et Ratio pour notre Afrique / Philosophie et Théologie pour les cultures africaines traditionnelles et modernes / Enseigner ou faire la philosophie en Afrique dans l’esprit de Fides et Ratio / Enseigner ou faire la théologie en Afrique dans l’esprit de Fides et Ratio ",
    communicateur: "Père Omer DAGAN / Professeur Albert NOUHOUAYI / Père Sylvestre GAINSI / Père Rodrigue GBÉDJINOU",
  },
  
]);


    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getTreeArticle(page_, limit_);
      } catch (error) {
        //
      }
    };

    function rechercher(){
        getTreeArticle(page.value, limit.value, searchTerm.value );
    }

    // END PAGINATE

    function getTreeArticle(page = 1, limi = 9, searchTerm = '') {
      return ApiService.get(`/actualite/articles/32?page=${page}&limit=${limi}&mot=${searchTerm}&`)
      
      .then(({ data }) => {
        articles.value = data.data.data;
        console.log("fff",articles.value)
        totalPages.value = data.data.totalPages;
        limit.value = data.data.limit;
        totalElements.value = data.data.totalElements;
      })
      .catch(({ response }) => {
        error(response.data.message)
      });
    } 

    const truncatedArticles = computed(() => {
        const maxLength = 100; 
        return articles.value.map(article => {
            if (article.titre.length > maxLength) {
            return {
                ...article,
                titre: article.titre.substring(0, maxLength) + '...'
            };
            }
            return article;
        });
    });

    // function getTreeArticle() {
    //   return ApiService.get(`/actualite/articles/22`)
    //     .then(({ data }) => {
    //       articles.value = data.data.data;
    //       console.log(articles.value);
    //       return data.data;
    //     })
    //     .catch(({ response }) => {
    //       error(response.message)
    //   });
    // }
    
    onMounted(() => {
        getTreeArticle();
    });

    return { 
        soireesTheologiques,
        articles,
        getUrlApiForFiles,
        format_Date,
        page, 
        totalPages,
        limit,
        totalElements,
        handlePaginate,
        truncatedArticles
    };
  },
});
</script>

<style scoped>
    .blog-card .blog-info h3 {
        font-size: 20px;
        line-height: 30px;
        margin-bottom: 15px;
    }
</style>